<ntap-prime-common-itemview #itemView></ntap-prime-common-itemview>
<ng-container *ngIf="itemView.activeTab === 1">
    <app-predmeti-restauracije></app-predmeti-restauracije>
</ng-container>
